module.exports = __webpack_public_path__ + "static/media/squooshed7.af7fe110.jpeg";